export const triggerComparisons = [
    {label: "Is", value: "is"},
    {label: "Is Not", value: "is_not"},
    {label: ">", value: "greater_than"},
    {label: ">=", value: "greater_than_equal"},
    {label: "<", value: "less_than"},
    {label: "<=", value: "less_than_equal"},
    {label: "Count", value: "count"}
];

export const addOptions = [
    {label: "Select one", value: "default", isDisabled: true},
    {label: "And", value: "and"},
    {label: "Or", value: "or"},
    {label: "Not", value: "not"}
];

export const aggFunctionOptions = [
    { label: 'Last Data Point', value: 'last' },
    { label: 'First Data Point', value: 'first' },
    { label: 'Sum', value: 'sum' },
    { label: 'Mean', value: 'avg' },
    { label: 'Count', value: 'count' },
];